import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PhysicianCouncilsParameter  extends Parameter {
    
    searchTerm: number;
    orderBy: string;

}
export interface PhysicianCouncils {


    id?: number;
    councilNum:string;
    date:Date;       
    councilId:any;
        
    physicianId:any;         
    tenantId: any;
    branchId: any;
    
    parameters?: PhysicianCouncilsParameter[];
    links?: any;

}


export abstract class PhysicianCouncilsData { 

    abstract list(url: string): Observable<PhysicianCouncils[]>;
    abstract create(url: string, data: PhysicianCouncils[]): Observable<any>;
    abstract update(url: string, data: PhysicianCouncils): Observable<any>;
    abstract delete(url: string): Observable<any>; 
   
}